import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/site/Form";
import { SettingsPanel } from "./IntegrationStatus";

export const ContentSettings = ({ s, save, owner }) => {
  const [c, setC] = useState(s.content);
  return (
    <SettingsPanel title="Privacy information & valuation terms" testid="content-panel">
      <p className="text-sm text-slate-600">
        These pages are public at <a className="link" href="/privacy" target="_blank" rel="noreferrer">/privacy</a> and <a className="link" href="/valuation-terms" target="_blank" rel="noreferrer">/valuation-terms</a>.
        Placeholders such as {"{{closed_months}}"} and {"{{business_name}}"} are filled in automatically from your settings. Replace the text in [square brackets] with your own details (company number, ICO registration). These drafts are not legal advice.
      </p>
      <Field label="Privacy information" htmlFor="privacy"><textarea id="privacy" rows={16} className="field-input font-mono text-sm" value={c.privacy} disabled={!owner} onChange={(e) => setC({ ...c, privacy: e.target.value })} data-testid="privacy-textarea" /></Field>
      <Field label="Valuation terms" htmlFor="terms"><textarea id="terms" rows={14} className="field-input font-mono text-sm" value={c.valuation_terms} disabled={!owner} onChange={(e) => setC({ ...c, valuation_terms: e.target.value })} data-testid="terms-textarea" /></Field>
      {owner && <Button onClick={() => save({ content: c })} data-testid="content-save-button">Save text</Button>}
    </SettingsPanel>
  );
};
